import { SEOMetadata } from '@/config/seo-meta';

export default function getCanonicalPath(router) {
  return `${SEOMetadata.baseCanonical}${router.asPath.split('?')?.[0]}`;
}
